import React from 'react';
import PropTypes from 'prop-types';
import { VisuallyHidden } from '../../atoms';
import { ResponsiveImage } from '../../molecules';
import {
  StyledTestimonial,
  StarRating,
  Name,
  Description,
  TextContainer,
} from './styles.js';

export const Testimonial = ({
  photo,
  rating,
  body,
  name,
  description,
  showStars = true,
}) => {
  return (
    <StyledTestimonial>
      <ResponsiveImage
        src={photo.src}
        alt={photo.alt}
        width={photo.width}
        height={photo.height}
      />
      <TextContainer>
        <Name>{name}</Name>
        <Description>{description}</Description>
        {showStars && (
          <StarRating rating={rating}>
            <VisuallyHidden>
              {rating} star rating for testimonial
            </VisuallyHidden>
          </StarRating>
        )}
        {body}
      </TextContainer>
    </StyledTestimonial>
  );
};

Testimonial.displayName = 'Testimonial';

Testimonial.propTypes = {
  photo: PropTypes.shape({
    src: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    alt: PropTypes.string.isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
  }).isRequired,
  description: PropTypes.string.isRequired,
  rating: PropTypes.number,
  body: PropTypes.node.isRequired,
  name: PropTypes.string.isRequired,
  showStars: PropTypes.bool,
};
